/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'info': {
    width: 14,
    height: 14,
    viewBox: '0 0 14 14',
    data: '<defs><path pid="0" d="M6.667 13.333A6.674 6.674 0 0 1 0 6.667 6.675 6.675 0 0 1 6.667 0a6.674 6.674 0 0 1 6.666 6.667 6.674 6.674 0 0 1-6.666 6.666Zm0-12a5.34 5.34 0 0 0-5.334 5.334A5.34 5.34 0 0 0 6.667 12 5.34 5.34 0 0 0 12 6.667a5.34 5.34 0 0 0-5.333-5.334Zm.666 7.334V6a.666.666 0 0 0-.666-.667H5.333v1.334H6v2H4.667V10h4V8.667H7.333Zm-.666-3.834a.833.833 0 1 0 0-1.666.833.833 0 0 0 0 1.666Z" id="svgicon_info_a"/></defs><use _fill="#686a7a" fill-rule="nonzero" xlink:href="#svgicon_info_a" transform="translate(.333 .333)"/>'
  }
})
